module.exports = __webpack_public_path__ + "1fcee1b88096db6b89d08fe86a711612.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/tree-top.png
// module id = 2949
// module chunks = 0